import { useState, useCallback } from 'react';
import { Contact } from '../types/Contact';
import { supabase } from '../lib/supabase';
import { User } from '@supabase/supabase-js';
import { updateContactCore } from '../lib/contactsCore';

export function useContactData(initialContact: Contact, user?: User | null) {
    const [formData, setFormData] = useState<Partial<Contact>>(initialContact);
    const [loading, setLoading] = useState(false);

    const handleInputChange = useCallback((field: keyof Contact, value: any) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    }, []);

    const handleSave = useCallback(async (onSave: () => void) => {
        setLoading(true);
        try {
            // Clean up empty date strings to null for database compatibility
            const cleanedFormData = {
                ...formData,
                next_follow_up: formData.next_follow_up || null,
                birthday: formData.birthday || null,
            };

            const dataToSave = {
                ...cleanedFormData,
                updated_at: new Date().toISOString(),
                updated_by: user?.id,
            } as any;

            await updateContactCore(supabase as any, String(initialContact.id), dataToSave);

            onSave();
        } catch (error) {
            console.error('Error saving contact:', error);
            alert('Error saving contact. Please try again.');
        }
        setLoading(false);
    }, [formData, initialContact.id, user?.id]);

    return {
        formData,
        setFormData,
        loading,
        handleInputChange,
        handleSave
    };
}
